<template>
    <div class="video" id="video">
      <!-- 课程列表 -->
        <div>
          
        </div>
    </div>
</template>

<script>
  export default {
    name: 'video',
    data () {
      return {
        
      }
    },
    methods:{
      
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/List.vue